import {
  CCol,
  CFormInput,
  CLoadingButton,
  CModalBody,
  CModalFooter,
  CRow,
} from "@coreui/react-pro";
import Layout from "./Layout";
import SModal from "@/components/shared/Modal/SModal";
import { useEffect, useState } from "react";
import axios from "../../../shared/config/axios-interceptor";
import { IGame } from "@/shared/model/game.model";
import {
  ToastErrorBottom,
  ToastSuccessBottom,
} from "@/components/shared/toast/Toast";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/reducers";
import { AppDispatch } from "@/store";
import { getProfile } from "../auth/auth.api";
import quay from "../../../assets/img/quay.png";
import KyQuay from "./KyQuay";
import InfoIcon from "@/components/shared/icons/web/InfoIcon";
import { NavLink } from "react-router-dom";
import BIcon from "@/components/shared/icons/web/BIcon";
import { ResponseStatus } from "@/shared/enumeration/ResponseStatus";
import { useRouter } from "@/shared/utils/hooks/useRouter";

const Home = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { navigate } = useRouter();

  const [modal, setModal] = useState(false);

  const [tienDat, setTienDat] = useState<number>(100);
  const [biDat, setBiDat] = useState<number>(0);
  const [ky, setKy] = useState<IGame | null>(null);
  const [ketQuaKyTruoc, setKetQuaKyTruoc] = useState<IGame | null>(null);
  const [disableDatCuoc, setDisableDatCuoc] = useState(false);
  const [load, setLoad] = useState(false);
  const { user } = useSelector((state: RootState) => state.authentication);

  const subTienDatHandle = () => {
    if (tienDat > 10000) {
      setTienDat(tienDat - 10000);
    }
  };

  const getKy = async () => {
    try {
      const response = await axios.get("/draws/get-current");
      setKy(response.data);
      console.log("Success:", response.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getKetQuaKyTruoc = async () => {
    try {
      const response = await axios.get("/draws/get-result-ket-qua-ky-truoc");
      setKetQuaKyTruoc(response.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    getKy();
    getKetQuaKyTruoc();
    dispatch(getProfile());
  }, [load]);

  const addTienDatHandle = () => {
    setTienDat(tienDat + 10000);
  };

  const money = [100, 500, 1000, 5000, 10000, 30000, 50000, 100000];

  const onChangeTienDatHandle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (Number.isNaN(Number(value))) return;
    setTienDat(Number(value));
  };

  const closeModal = () => {
    setModal(false);
    setBiDat(0);
  };

  const openModal = (biDat: number) => {
    setModal(true);
    setBiDat(biDat);
  };

  const [loading, setLoading] = useState(false);

  const submitHanle = async () => {
    if (user?.status === ResponseStatus.CAMGIAODICH) {
      ToastErrorBottom("Tài khoản của bạn đã bị cấm giao dịch.");
      return;
    }

    if (user?.status === ResponseStatus.INACTIVE) {
      ToastErrorBottom("Hệ thống đanng bảo trì");
      localStorage.clear();
      navigate("/login");
      return;
    }

    if (disableDatCuoc) {
      ToastErrorBottom("Đã hết thời gian đặt cược");
      setModal(false);
      setBiDat(0);
      return;
    }

    if ((user?.money && user?.money < tienDat) || user?.money == 0) {
      ToastErrorBottom("Số dư không đủ");
      setModal(false);
      setBiDat(0);
      return;
    }

    if (tienDat <= 10) {
      ToastErrorBottom("Vui lòng nhập số tiền cược lớn hơn 10");
      setModal(false);
      setBiDat(0);
      return;
    }

    try {
      setLoading(true);
      await axios.post("/history", {
        KyId: ky?.id,
        voted: biDat,
        money: tienDat,
      });
      setLoading(false);
      setModal(false);
      setBiDat(0);
      setTienDat(100);
      ToastSuccessBottom("Đặt cược thành công");
      dispatch(getProfile());
    } catch (error) {
      setModal(false);
      setBiDat(0);
      ToastErrorBottom("Đặt cược thất bại");
      dispatch(getProfile());
      setLoading(false);
      console.error("Error:", error);
    }
  };

  return (
    <Layout>
      <KyQuay
        load={load}
        ky={ky}
        setDisableDatCuoc={setDisableDatCuoc}
        setLoad={setLoad}
      />

      <div className="item-history d-flex justify-content-between align-items-center">
        <div style={{ fontSize: 16 }} className="fw-bold">
          FAMILYMILK
        </div>
        <div>Kết quả đơn hàng {(ky?.id ?? 0) - 1}</div>
        <div>
          <NavLink to="/info">
            <InfoIcon
              color="#fff"
              fill="#113b49"
              style={{ borderRadius: "50%", background: "#fff" }}
            />
          </NavLink>
        </div>
      </div>

      <div className="box-result d-flex justify-content-center align-items-center">
        <div className="text-center">
          <div className="list-ball d-flex justify-content-between gap-2">
            <div className="ball">
              <span>{ketQuaKyTruoc?.ball1 || 0}</span>
            </div>
            <div className="ball">
              <span>{ketQuaKyTruoc?.ball2 || 0}</span>
            </div>
            <div className="ball">
              <span>{ketQuaKyTruoc?.ball3 || 0}</span>
            </div>
            <div className="ball">
              <span>{ketQuaKyTruoc?.ball4 || 0}</span>
            </div>
            <div className="ball">
              <span>{ketQuaKyTruoc?.ball5 || 0}</span>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{ backgroundColor: "#113b49", height: 67 }}
        className="d-flex justify-content-center align-items-center"
      >
        <div
          className="fw-bold d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "#ff632c",
            color: "#fff",
            paddingTop: 5,
            paddingBottom: 5,
            paddingLeft: 10,
            paddingRight: 10,
            borderRadius: 3,
            borderColor: "#fff",
            borderWidth: 2,
            borderStyle: "solid",
          }}
        >
          NUTIFOOD - TH TRUEMILK - VINAMILK
        </div>
      </div>

      <div className="d-flex justify-content-center align-items-center mt-3">
        <div
          style={{
            background: "#113b49",
            color: "#fff",
            padding: 4,
            fontSize: 14,
            borderRadius: 3,
          }}
        >
          Thương hiệu mang tới "hạnh phúc đích thực"
        </div>
      </div>

      {/* <div className="button-box text-center mt-3">
        <CButton>Việc kinh doanh</CButton>
      </div> */}

      <div className="box-datcuoc mt-3">
        <div>
          <div className="d-flex gap-2">
            <button
              style={{ background: "rgb(154, 195, 223)", height: 55 }}
              className={
                biDat === 1
                  ? "active justify-content-center"
                  : "justify-content-center"
              }
              onClick={() => openModal(1)}
            >
              <span style={{ marginTop: 5, fontSize: 16 }}>TH TRUEMILK</span>
              <img
                style={{ width: 40, height: 20 }}
                src="data:image/png;base64,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"
              />
            </button>
            <button
              style={{ background: "#83ba47", height: 55 }}
              className={
                biDat === 2
                  ? "active justify-content-center"
                  : "justify-content-center"
              }
              onClick={() => openModal(2)}
            >
              <span style={{ marginTop: 5, fontSize: 16 }}>VINAMILK</span>

              <img
                style={{ width: 40, height: 20 }}
                src="data:image/png;base64,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"
              />
            </button>
          </div>

          <div className="d-flex gap-2">
            <button
              className={
                biDat === 3
                  ? "active custombutton d-flex justify-content-between"
                  : "d-flex justify-content-between custombutton"
              }
              onClick={() => openModal(3)}
            >
              Sữa mộc châu
              <BIcon />
            </button>
            <button
              className={
                biDat === 4
                  ? "active custombutton d-flex justify-content-between"
                  : "d-flex justify-content-between custombutton"
              }
              onClick={() => openModal(4)}
            >
              Sữa cô gái hà lan
              <BIcon />
            </button>
          </div>

          <div className="d-flex gap-2">
            <button
              className={
                biDat === 5
                  ? "active custombutton d-flex justify-content-between"
                  : "d-flex justify-content-between custombutton"
              }
              onClick={() => openModal(5)}
            >
              SỮA NUTIFOOD
              <BIcon />
            </button>
            <button
              className={
                biDat === 6
                  ? "active custombutton d-flex justify-content-between"
                  : "d-flex justify-content-between custombutton"
              }
              onClick={() => openModal(6)}
            >
              SỮA OPTIMUM GOLD SỐ 2
              <BIcon />
            </button>
          </div>

          <div className="d-flex gap-2">
            <button
              className={
                biDat === 7
                  ? "active custombutton d-flex justify-content-between"
                  : "d-flex justify-content-between custombutton"
              }
              onClick={() => openModal(7)}
            >
              SỮA DUTCH LADY
              <BIcon />
            </button>
            <button
              className={
                biDat === 8
                  ? "active custombutton d-flex justify-content-between"
                  : "d-flex justify-content-between custombutton"
              }
              onClick={() => openModal(8)}
            >
              SỮA MILO
              <BIcon />
            </button>
          </div>

          <div className="d-flex gap-2">
            <button
              className={
                biDat === 9
                  ? "active custombutton d-flex justify-content-between"
                  : " d-flex justify-content-between custombutton"
              }
              onClick={() => openModal(9)}
            >
              SỮA ANFA GOLD
              <BIcon />
            </button>
            <button
              className={
                biDat === 10
                  ? "active custombutton d-flex justify-content-between"
                  : "d-flex justify-content-between custombutton"
              }
              onClick={() => openModal(10)}
            >
              SỮA ĐẬU NÀNH FAMI
              <BIcon />
            </button>
          </div>
        </div>
      </div>

      {/* <div className="mt-3">
        <CCarousel controls interval={3000}>
          <CCarouselItem>
            <CImage className="d-block w-100" src={image1} alt="slide 1" />
          </CCarouselItem>
          <CCarouselItem>
            <CImage className="d-block w-100" src={image2} alt="slide 2" />
          </CCarouselItem>
          <CCarouselItem>
            <CImage className="d-block w-100" src={image3} alt="slide 3" />
          </CCarouselItem>
        </CCarousel>
      </div> */}

      <div className="d-flex justify-content-center align-items-center mt-3 px-3">
        <div
          className="p-1 text-center"
          style={{
            background: "#113b49",
            color: "#fff",
            padding: 4,
            fontSize: 13,
            borderRadius: 3,
          }}
        >
          HÈ SÔI ĐỘNG CÙNG TH TRUMILK VỚI NHỮNG PHẦN QUÀ CÓ GIÁ TRỊ LÊN TỚI
          100TR ĐỒNG
        </div>
      </div>

      <div className="text-center my-3">
        <img className="box-quay-img" src={quay} width={150} height={150} />
      </div>

      <div
        style={{ color: "#113b49", fontSize: 15 }}
        className="mt-3 text-center px-3 text-uppercase"
      >
        Hệ thống đang tự động tìm kiếm khách hàng may mắn
      </div>

      <SModal
        alignment="center"
        visible={modal}
        backdrop="static"
        className="custom-modal custom-modal-datcuoc"
      >
        {/* <CModalHeader>dsadas</CModalHeader> */}
        <CModalBody>
          <div>
            <div className="text-center mb-3">Số lượng</div>

            <div className="form-input d-flex gap-3 justify-content-center align-items-center">
              <div
                className="sub"
                onClick={subTienDatHandle}
                style={{ cursor: "pointer" }}
              >
                -
              </div>
              <CFormInput
                onChange={(e) => onChangeTienDatHandle(e)}
                className="text-center fw-normal"
                type="text"
                value={tienDat}
              />
              <div
                className="add"
                onClick={addTienDatHandle}
                style={{ cursor: "pointer" }}
              >
                +
              </div>
            </div>

            <CRow className="box-list-fill mt-4">
              {money.map((item, index) => {
                return (
                  <CCol xs={3} key={index}>
                    <div
                      className={
                        "fill mb-2" + (item === tienDat ? " active" : "")
                      }
                      onClick={() => setTienDat(item)}
                      style={{ cursor: "pointer", fontSize: 13 }}
                    >
                      <span>
                        {new Intl.NumberFormat("vi-VN").format(item || 0)}
                      </span>
                    </div>
                  </CCol>
                );
              })}
            </CRow>
          </div>
        </CModalBody>
        <CModalFooter className="d-flex justify-content-around">
          <div
            className="cancel"
            onClick={closeModal}
            style={{
              background: "rgb(204, 204, 204)",
              paddingTop: 5,
              paddingBottom: 5,
              paddingLeft: 25,
              paddingRight: 25,
              borderRadius: 25,
              fontSize: 14,
            }}
          >
            Hủy bỏ
          </div>
          <CLoadingButton
            className="submit"
            onClick={submitHanle}
            style={{
              paddingTop: 5,
              paddingBottom: 5,
              paddingLeft: 25,
              paddingRight: 25,
              borderRadius: 25,
              backgroundColor: "#113b49",
              color: "#fff",
              fontSize: 14,
            }}
            loading={loading}
            disabled={loading}
          >
            Xác nhận
          </CLoadingButton>
        </CModalFooter>
      </SModal>
    </Layout>
  );
};

export default Home;
